<div class="cf-flex-column">
  <div class="cf-flex-row cf-flex-wrap cf-fill cf-justify-content-space-between">
    <div class="mat-headline-6" data-test="ProductList">{{ 'UI.Project.Text.ProductList' | translate }}</div>
  </div>
  <div>
    <div class="ac-table-container">
      <table class="ac-table" mat-table [dataSource]="dataSource" [trackBy]="trackByEntity">
        <ng-container matColumnDef="entityName" sticky>
          <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'UI.Common.Text.HoodName' | translate }}</th>
          <td class="table-text-column" mat-cell *matCellDef="let row" data-test="Name">
            {{ row.entity.Properties['Name'].Value }}
            <app-message-icon *ngIf="row.messageLevels.hasErrors" [messageLevel]="0"></app-message-icon>
            <app-message-icon *ngIf="row.messageLevels.hasWarnings" [messageLevel]="1"></app-message-icon>
            <app-message-icon *ngIf="row.messageLevels.hasInfo" [messageLevel]="2"></app-message-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="entitySupplyAirFlow">
          <th class="table-text-column" mat-header-cell *matHeaderCellDef>
            {{ 'UI.Common.Text.TotalSupplyAir' | translate }}
            <span *ngIf="airflowMeasurementUnit$ | async as airflowUnit">({{ airflowUnit.TextId | translate }})</span>
          </th>
          <td class="table-text-column" mat-cell *matCellDef="let row" data-test="SupplyAirFlow">
            <app-numeric-property-display [property]="row.entity.Properties.SupplyAirFlow"></app-numeric-property-display>
          </td>
        </ng-container>

        <ng-container matColumnDef="entityExtractAirFlow">
          <th class="table-text-column" mat-header-cell *matHeaderCellDef>
            {{ 'UI.Common.Text.TotalExtractAir' | translate }}
            <span *ngIf="airflowMeasurementUnit$ | async as airflowUnit">({{ airflowUnit.TextId | translate }})</span>
          </th>
          <td class="table-text-column" mat-cell *matCellDef="let row" data-test="ExtractAirFlow">
            <app-numeric-property-display [property]="row.entity.Properties.ExtractAirFlow"></app-numeric-property-display>
          </td>
        </ng-container>

        <ng-container matColumnDef="entityDateModified">
          <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'Common.DateModified' | translate }}</th>
          <td class="table-text-column" mat-cell *matCellDef="let row">
            {{ row.entity.DateModified | date : 'short' : (uiLocale$ | async) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="entityDateCreated">
          <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'Common.DateCreated' | translate }}</th>
          <td class="table-text-column" mat-cell *matCellDef="let row">
            {{ row.entity.DateCreated | date : 'short' : (uiLocale$ | async) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="entityIncludeInExports">
          <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'UI.Common.Text.IncludeInExports' | translate }}</th>
          <td class="table-text-column" mat-cell *matCellDef="let row" data-test="IncludeInExports" (click)="$event.stopPropagation()">
            <mat-checkbox
              color="primary"
              [checked]="row.entity.Properties.IncludeInExports.Value"
              (change)="toggleHoodExport($event, row.entity.Id)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="entityVersion">
          <th class="table-text-column" mat-header-cell *matHeaderCellDef>{{ 'UI.Common.Text.Version' | translate }}</th>
          <td class="table-text-column" mat-cell *matCellDef="let row" data-test="Version">{{ row.entity.Properties.Version.Value }}</td>
        </ng-container>

        <ng-container matColumnDef="entityCopyAction">
          <th class="table-action-column" mat-header-cell *matHeaderCellDef></th>
          <td class="table-action-column" mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
            <button
              data-test="copyButton"
              matSuffix
              class="ac-table-button"
              mat-icon-button
              disableRipple="true"
              aria-label="Copy hood"
              (click)="onCopyClick(row.entity)"
              [matTooltip]="'UI.ProductAction.CopyToAnotherProject' | translate"
              matTooltipPosition="above"
              [disabled]="(canAddHood$ | async) === false"
            >
              <mat-icon svgIcon="content_copy"></mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="entityDeleteAction">
          <th class="table-action-column" mat-header-cell *matHeaderCellDef></th>
          <td class="table-action-column" mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
            <button
              data-test="deleteButton"
              matSuffix
              class="ac-table-button"
              mat-icon-button
              disableRipple="true"
              aria-label="Delete hood"
              (click)="onDeleteClick(row.entity)"
              [matTooltip]="'UI.Common.Action.Delete' | translate"
              matTooltipPosition="above"
              [disabled]="(canDeleteHood$(row.entity.Id) | async) === false"
            >
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="entityEditAction">
          <th class="table-action-column" mat-header-cell *matHeaderCellDef></th>
          <td class="table-action-column" mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
            <button
              data-test="editButton"
              matSuffix
              class="ac-table-button"
              mat-icon-button
              disableRipple="true"
              aria-label="Edit hood"
              (click)="onEditClick(row.entity)"
              [matTooltip]="'UI.Common.Action.Edit' | translate"
              matTooltipPosition="above"
            >
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [attr.data-test]="row.entity.Id + '-DataRow'"
          (click)="onRowClick(row.entity)"
        ></tr>
      </table>
    </div>

    <mat-paginator
      class="ac-table-paginator"
      (page)="handlePageEvent($event)"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [length]="projectEntity?.Children.length"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      aria-label="Select page"
    ></mat-paginator>
  </div>
</div>
